module.exports = "<div class=\"th__content__order\">\n  <a (click)=\"onSort(false)\" [class.active]=\"isSelected(false)\" class=\"order order__up\"></a>\n  <a (click)=\"onSort(true)\" [class.active]=\"isSelected(true)\" class=\"order order__bottom\"></a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/sort-control/sort-control.component.html
// module id = ../../../../../src/app/shared/components/sort-control/sort-control.component.html
// module chunks = main